export const PRICE = '23 USD'

export const BRAND = 'Cosmetology Instructor Ready™'

/** Section 2 — real interior pages from Volume 2, in this exact order. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/gi6Tm5Bqre1Wdw2nCvLv1W/01_Page_10.png',
    caption: 'Face-Zone Observation Map — Page 10',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5L4o3adDrP86ECRTEFXLkK/02_Page_16.png',
    caption: 'Dry vs. Dehydrated Skin — Page 16',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7jTyS6rq9Dj5n62bEBN5SP/03_Page_23.png',
    caption: 'Pigmentation & Skin Tone Observation — Page 23',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5mZLqj79txhFVB64XmaBgE/04_Page_28.png',
    caption: 'Contraindications, Red Flags & Service Safety — Page 28',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7htPPRFNXKcfa8Tjw3ToiC/05_Page_42.png',
    caption: 'Instructor Quick-Teach Toolkit — Page 42',
  },
]

/** Section 3 — pain points. */
export const painPoints = [
  {
    title: 'Hours Preparing Lessons',
    text: 'Searching for information, organizing topics and deciding what to teach.',
  },
  {
    title: 'Resources Everywhere',
    text: 'Notes, websites, screenshots and documents scattered across different places.',
  },
  {
    title: 'Complex Topics to Explain',
    text: 'Skin science, analysis and ingredients can be difficult to make clear for students.',
  },
  {
    title: 'Creating Everything Yourself',
    text: 'Activities, assessments, visual references and teaching materials take time.',
  },
]

/** Section 4 — the transformation. */
export const oldFlow = ['Search', 'Organize', 'Create', 'Teach']
export const newFlow = ['Open', 'Prepare', 'Teach', 'Assess']

/** Section 5 — why this is different. */
export const differentiators = [
  {
    title: 'Skin-First',
    text: 'Strong emphasis on skin science, skin analysis and professional observation.',
  },
  {
    title: 'Visual',
    text: 'Maps, comparisons, diagrams, frameworks and quick-reference tools.',
  },
  {
    title: 'Built for Educators',
    text: 'Designed around what instructors need to explain, demonstrate, practice and assess.',
  },
  {
    title: 'Ready to Use',
    text: 'Spend less time building resources and more time actually teaching.',
  },
]

/** Section 6 — the six volumes. Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Cosmetology Science & Skin Foundations',
    description:
      'The scientific foundation behind professional cosmetology education: skin anatomy, functions, barrier concepts, skin types and essential beauty science.',
    accent: '#F6EBD3',
    mark: 'star',
  },
  {
    number: 2,
    title: 'Skin Analysis, Conditions & Client Assessment',
    description:
      'Teach students how to observe skin systematically, distinguish common cosmetic concerns and make safer professional decisions.',
    accent: '#F7D6D6',
    mark: 'flame',
  },
  {
    number: 3,
    title: 'Facial Care, Skin Preparation & Treatment Fundamentals',
    description:
      'A structured foundation for teaching facial care, preparation, sequencing, product use and service adaptation.',
    accent: '#D6E9EC',
    mark: null,
  },
  {
    number: 4,
    title: 'Cosmetic Ingredients, Products & Beauty Science',
    description:
      'Help students understand ingredient functions, formulations, product categories, labels and the science behind cosmetic products.',
    accent: '#DED5F3',
    mark: 'star',
  },
  {
    number: 5,
    title: 'Hair, Scalp, Nail & Brow Health Fundamentals',
    description:
      'Foundational health, anatomy, observation, hygiene and safety knowledge across key cosmetology areas — without becoming a specialized technique manual.',
    accent: '#F5DEBC',
    mark: null,
  },
  {
    number: 6,
    title: 'The Cosmetology Educator Teaching & Assessment System',
    description:
      'Turn knowledge into better classes with lesson structure, demonstrations, student practice, assessments, feedback and progress tracking.',
    accent: '#D9D1F0',
    mark: 'flame',
  },
]

/** Section 7 — visual resources included. */
export const visualResources = [
  'Skin analysis maps',
  'Skin type comparisons',
  'Client assessment frameworks',
  'Facial-care sequences',
  'Ingredient guides',
  'Product education',
  'Safety decision tools',
  'Teaching frameworks',
  'Student practice activities',
  'Assessment resources',
  'Instructor checklists',
  'Quick-reference materials',
]

/** Section 8 — the five bonuses. */
export const bonuses = [
  {
    number: 'Bonus #1',
    title: 'The Skin Analysis Visual Reference Atlas™',
    description: 'Visual maps, comparisons and quick-reference tools for teaching skin observation.',
    accent: '#F7D6D6',
  },
  {
    number: 'Bonus #2',
    title: 'The Cosmetic Ingredient Cheat Sheet Library™',
    description: 'Fast visual references for ingredient functions, categories and product education.',
    accent: '#DED5F3',
  },
  {
    number: 'Bonus #3',
    title: 'The Client Consultation & Safety Form Pack™',
    description: 'Ready-to-use forms, checklists and documentation tools for student practice.',
    accent: '#D6E9EC',
  },
  {
    number: 'Bonus #4',
    title: 'The Cosmetology Classroom Activity Vault™',
    description: 'Ready-to-run activities that turn beauty science into interactive learning.',
    accent: '#F5DEBC',
  },
  {
    number: 'Bonus #5',
    title: 'The Skin & Beauty Science Student Workbook™',
    description: 'Structured student practice designed to reinforce understanding and application.',
    accent: '#F6EBD3',
  },
]

/** Section 9 — who it is for. */
export const audience = [
  'Cosmetology Instructors',
  'Beauty School Teachers',
  'Independent Beauty Educators',
  'Academy Owners',
  'Cosmetology Trainers',
]

/** Section 10 — before and after. */
export const beforeList = [
  'Searching for lesson material',
  'Creating resources from scratch',
  'Scattered notes and references',
  'Struggling to explain complex topics',
  'Building activities and assessments manually',
]

export const afterList = [
  'Structured teaching resources',
  'Visual explanations ready to use',
  'Clear topic organization',
  'Classroom activities and tools',
  'More confidence walking into class',
]

/** Section 11 — value stack. */
export const offerIncludes = [
  '6 Complete Teaching Volumes',
  '5 Premium Bonuses',
  'Skin-First Education System',
  'Teaching & Assessment Resources',
  'Instant Digital Access',
]

export const faqs = [
  {
    question: 'Is this for cosmetology instructors?',
    answer:
      'Yes. It was specifically created for cosmetology instructors, beauty school teachers, independent educators and academy owners.',
  },
  {
    question: 'Is this a student textbook?',
    answer:
      'No. It is primarily an instructor-focused teaching system, although many resources can also support student learning and practice.',
  },
  {
    question: 'Does it focus mainly on skin?',
    answer:
      'Yes. Skin science, skin analysis, client assessment, facial care and cosmetic ingredients are the core focus. Hair, scalp, nails and brows are covered as foundational cosmetology health topics.',
  },
  {
    question: 'Do I receive physical books?',
    answer: 'No. Cosmetology Instructor Ready™ is a digital product.',
  },
  {
    question: 'Can I use the resources in my classes?',
    answer:
      "The system is designed specifically to support class preparation, instruction, student practice and assessment, subject to the product's usage terms.",
  },
  {
    question: 'How do I receive it?',
    answer: 'Access is delivered digitally after purchase.',
  },
  {
    question: 'Is the payment secure?',
    answer: 'Yes. Checkout is secure and encrypted, and your payment is processed in your local currency.',
  },
]
